/*
 * Copyright 1999-2025 Jagex Ltd.
 */
export enum LoaderName {
  CreateAccount = 'game-accounts--create-account'
}
